import { useParams } from "react-router";
import { useListApplicationApplicantDetailsQuery } from "@lending/hooks/queries/ApplicationApplicantDetails/useListApplicationApplicantDetailsQuery";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";
import { findPrimaryApplicant } from "@lending/utils/applicantHelpers";
import styles from "./GlobalHeader.module.css";
import { UserMenu } from "../UserMenu/UserMenu";

interface GlobalHeaderProps {
  flowType: "web" | "olb";
}

function GlobalHeader({ flowType }: GlobalHeaderProps) {
  const { institution } = useGetInstitutionQuery();
  // Route only, never the store's id: it outlives the flow that set it. Keep
  // "" — handed undefined, the query hook falls back to that id itself.
  const { applicationUuid: pathApplicationUuid } = useParams<{ applicationUuid: string }>();
  const applicationIdParam = new URLSearchParams(window.location.search).get("olb_application");
  const applicationUuid = pathApplicationUuid ?? applicationIdParam ?? "";

  const applicants = useListApplicationApplicantDetailsQuery({ applicationUuid });
  const applicant = findPrimaryApplicant(applicants?.data?.results);

  // Logo URL based on flow type
  const logoUrl =
    flowType === "olb"
      ? institution.lending_return_to_banking_url
      : String(institution.lending_website_flow_logo_nav_url ?? "");

  return (
    <nav className={styles.globalHeader}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.institutionLogo}>
            <a href={logoUrl}>
              <img src={institution.logo_url} alt={institution.short_name} role="presentation" />
            </a>
          </div>
          <UserMenu firstName={applicant?.first_name} lastName={applicant?.last_name} />
        </div>
      </div>
    </nav>
  );
}

export { GlobalHeader };
